export default {
  DEA1_PLUS: 'DEA1+'
}
